import Button from 'apollo-react/components/Button';
import React, { useContext } from 'react';

import { useFormSelector } from '../../../../custom-hooks';
import { useTranslation } from '../../../../custom-hooks/useTranslation';
import { navigateToControlFCM } from '../../../../utils/domUtils';
import { FormContext } from '../../../context';
import { getFormModel } from '../../../selectors/common.selectors';

const NavigationCell = ({ row: { id, collapseBlade } }) => {
  const translateString = useTranslation();
  const formKey = useContext(FormContext);
  const formModel = useFormSelector(getFormModel);

  const onClickHandler = () => {
    collapseBlade();
    navigateToControlFCM(id, formKey, formModel);
  };

  return (
    <Button variant="primary" size="small" onClick={onClickHandler}>
      {translateString('Navigate')}
    </Button>
  );
};

export default NavigationCell;
